import styled from 'styled-components';

export const AnalyticsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const DateRangeSelector = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: #2a2a2a;
  border: 1px solid #404040;
  border-radius: 8px;
  flex-wrap: wrap;
`;

export const DateRangeButton = styled.button<{ active?: boolean }>`
  padding: 8px 16px;
  background: ${props => props.active ? '#3b82f6' : '#1a1a1a'};
  color: ${props => props.active ? '#ffffff' : '#888'};
  border: 1px solid ${props => props.active ? '#3b82f6' : '#404040'};
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: ${props => props.active ? '#2563eb' : '#2a2a2a'};
    color: ${props => props.active ? '#ffffff' : '#fff'};
    border-color: ${props => props.active ? '#2563eb' : '#555'};
  }
`;

export const DateInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #1a1a1a;
  border: 1px solid #404040;
  border-radius: 6px;
  color: #888;
`;

export const DateInput = styled.input`
  background: transparent;
  border: none;
  color: #fff;
  font-size: 14px;
  outline: none;
  cursor: pointer;
  
  &::-webkit-calendar-picker-indicator {
    filter: invert(1);
    cursor: pointer;
  }
`;

export const ChartsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`;

export const ChartPanel = styled.div`
  background: #2a2a2a;
  border: 1px solid #404040;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ChartHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ChartTitle = styled.h3`
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  margin: 0;
`;

export const ChartUnit = styled.span`
  font-size: 12px;
  color: #888;
  font-weight: 400;
`;

export const ChartWrapper = styled.div`
  height: 250px;
  width: 100%;
  position: relative;
`;

export const NoDataMessage = styled.div`
  background: #2a2a2a;
  border: 1px solid #404040;
  border-radius: 8px;
  padding: 40px;
  text-align: center;
  color: #888;
  font-size: 16px;
`;
